module.exports = __webpack_public_path__ + "img/19_68.8e4ec112.png";